import { IconName } from '@bytel/trilogy-react';

export enum FaiTabsEnum {
    // also used as url hash
    PURE_BYOU = 'purebyou',
    BOX_INTERNET = 'box-internet',
    BOX_5G = '5gbox',
    FIN_DE_SERIE = 'fin-de-serie',
    BIG = 'big',
}

export type TabConfigItem = {
    name: string;
    icon: IconName;
    order: number;
};

export type TabConfig = {
    [key in FaiTabsEnum]?: TabConfigItem;
};

export type ExtraCmsBlockByTab = {
    [key in FaiTabsEnum]?: string;
};
